import { useSelector } from "react-redux";
import useProductBrandActions from './_actions';

export const useProductBrand = () => {
      const {
            getAllProductBrandList,
            createProductBrand,
            updateProductBrand,
            deleteProductBrand,

            changeCurrentPage,
            changeRowsPerPage,
            changeSearchTerm,
            refreshDialogState
      } = useProductBrandActions();

      const productBrand = useSelector(state => state.productBrand.data);
      const currentPage = useSelector(state => state.productBrand.currentPage);
      const totalRows = useSelector(state => state.productBrand.totalRows);
      const rowsPerPage = useSelector(state => state.productBrand.rowsPerPage);
      const searchTerm = useSelector(state => state.productBrand.searchTerm);

      const isLoading = useSelector(state => state.productBrand.isLoading);
      const isError = useSelector(state => state.productBrand.isError);
      const errorMessage = useSelector(state => state.productBrand.errorMessage);
      const apiAction = useSelector(state => state.productBrand.action);
      const dialogStates = useSelector(state => state.productBrand.dialogStates);

      return {
            //state
            productBrand,
            isLoading,
            isError,
            errorMessage,
            currentPage,
            rowsPerPage,
            totalRows,
            searchTerm,
            apiAction,
            dialogStates,
            
            //actions
            getAllProductBrandList,
            createProductBrand,
            updateProductBrand,
            deleteProductBrand,
            changeCurrentPage,
            changeRowsPerPage,
            changeSearchTerm,
            refreshDialogState
      }
}

export { default as productBrandReducer } from './_reducers';